import * as yup from 'yup';
import { FormInputMeta } from "@Modules/core/types/FormMetaType";
import { getValidationSchema } from '@Shared/utils/validationSchema';
export interface IProfileFormMeta {
  firstName: FormInputMeta,
  lastName: FormInputMeta,
  gender: FormInputMeta,
  dateOfBirth: FormInputMeta,
  username: FormInputMeta,
  function: FormInputMeta,
  email: FormInputMeta,
  placeOfBirth: FormInputMeta,
  schema: any,
}

const ProfileFormMeta: IProfileFormMeta = {} as IProfileFormMeta;

ProfileFormMeta.firstName = {
  label: 'First Name',
  name: 'firstName',
  type: 'text',
  placeholder: 'First Name',
  validation: yup.string().required("Champ obligatoire !"),
};

ProfileFormMeta.lastName = {
  label: 'Last Name',
  name: 'lastName',
  type: 'text',
  placeholder: 'Last Name',
  validation: yup.string().required("Champ obligatoire !"),
};

ProfileFormMeta.gender = {
  label: 'Sexe',
  name: 'gender',
  type: 'select',
  placeholder: 'Sexe',
  options: [
    {
      label: 'Homme',
      value: 'men',
    },
    {
      label: 'Femme',
      value: 'women',
    },
  ],
  validation: yup.string().required("Champ obligatoire !"),
};

ProfileFormMeta.function = {
  label: 'Poste / Fonction',
  name: 'function',
  type: 'text',
  placeholder: 'Function',
  validation: yup.string().required("Champ obligatoire !"),
};

ProfileFormMeta.placeOfBirth = {
  label: 'Lieu de naissance',
  name: 'placeOfBirth',
  type: 'text',
  placeholder: 'Place Of Birth',
  validation: yup.string().required("Champ obligatoire !"),
};

ProfileFormMeta.dateOfBirth = {
  label: 'Date de naissance',
  name: 'dateOfBirth',
  type: 'date',
  placeholder: 'Date de naissance',
  validation: yup.string().required("Champ obligatoire !"),
};

ProfileFormMeta.email = {
  label: 'Adresse Email',
  name: 'email',
  type: 'email',
  placeholder: 'Adresse Email',
  validation: yup.string().required("Champ obligatoire !"),
};

ProfileFormMeta.username = {
  label: 'Nom d\'utilisateur',
  name: 'username',
  type: 'text',
  placeholder: 'Last Name',
  validation: yup.string().required("Champ obligatoire !"),
};

const validationSchema = getValidationSchema(ProfileFormMeta);
ProfileFormMeta.schema = yup.object().shape(validationSchema);

export default ProfileFormMeta;